module.exports = __webpack_public_path__ + "img/hero-section-custom.7862a9f4.png";